import { Platform, Text, View, Image, TouchableOpacity, Dimensions } from "react-native";
import { Stack, useRouter } from "expo-router";
import { Ionicons } from "@expo/vector-icons";

function LogoSmall() {
  if (Platform.OS === "web") {
    return <img src="/logo-main.png" alt="Dash-Hound" style={{ height: 32, objectFit: "contain" } as any} />;
  }
  return <Image source={require("../../../assets/images/logo-main.png")} style={{ height: 32, width: 120 }} resizeMode="contain" />;
}

function DogsHeader() {
  const router = useRouter();
  const sw = Dimensions.get("window").width - 32;
  return (
    <View style={{ flexDirection: "row", alignItems: "center", width: sw }}>
      <View style={{ width: sw / 3, alignItems: "flex-start" }}>
        <LogoSmall />
      </View>
      <View style={{ width: sw / 3, alignItems: "center" }}>
        <Text style={{ fontSize: 18, fontWeight: "700", color: "#1B2A4A" }}>Dogs</Text>
      </View>
      <View style={{ width: sw / 3, alignItems: "flex-end" }}>
        <TouchableOpacity
          onPress={() => router.push("/(tabs)/dogs/add" as any)}
          style={{
            backgroundColor: "#1B2A4A",
            flexDirection: "row",
            alignItems: "center",
            paddingHorizontal: 10,
            paddingVertical: 6,
            borderRadius: 8,
            gap: 3,
          }}
        >
          <Ionicons name="add" size={14} color="#FFFFFF" />
          <Text style={{ color: "#FFFFFF", fontWeight: "600", fontSize: 12 }}>Add Dog</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
}

// Anchor the Dogs stack on `index`. When we land on a deep route like
// `followers` via router.replace (returning from a follower's dog profile),
// this keeps the dog list as the base of the stack instead of leaving
// followers as the only screen. That's what lets the Dogs-tab reset (popToTop
// in (tabs)/_layout) pop back to the list instead of getting stuck.
export const unstable_settings = { initialRouteName: "index" };

export default function DogsLayout() {
  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: "#ffffff" },
        headerShadowVisible: false,
      }}
    >
      <Stack.Screen name="index" options={{ headerTitle: () => <DogsHeader /> }} />
      <Stack.Screen name="add" options={{ title: "Add Dog", headerShown: false }} />
      <Stack.Screen name="[id]" options={{ title: "Dog Profile", headerShown: false }} />
      <Stack.Screen name="followers" options={{ title: "Followers", headerShown: false }} />
      <Stack.Screen name="dogview/[slug]" options={{ title: "Dog", headerShown: false }} />
    </Stack>
  );
}
